/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import clsx from 'clsx';
import {
    Grid,
    Paper,
    TextField,
    Typography,
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    FormControlLabel, Button, Avatar, Box, InputAdornment
} from '@mui/material';
import { Col, Row } from "antd";
import { Link, NavLink } from "react-router-dom";
import customStyles from "../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import { customerTypeList, customerBusinessTypeList } from "../../../../config/constant";
import actions from "../../redux/actions";
import logoImg from "../../../../assets/images/logo.png";
import registerImg from "../../../../assets/images/register.png";
import usePrevious from "../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { Image } from "antd";
import addressActions from "../../../Admin/Address/redux/actions";
import { checkLogin, scrollToError, idNamingConversion } from '../../../../helpers/utilities';
import { emptyValidation, customEmailValidation, customPhoneValidation, customAlaphabetValidation } from "../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../Shared/components/AutoCompleteComponent";
import { NormalSelect } from "../../../Shared/components/CustomSelect";
import { SelectedIcon, UnSelectedIcon } from "../../../Shared/components/Icons/selectedIcon";

const Register = (props) => {
    const { registerLoader } = useSelector(state => state.authReducer);
    const { areaDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const [fullName, setFullName] = useState('');
    const [customerType, setCustomerType] = useState('BUSINESS');
    const [customerBusinessType, setCustomerBusinessType] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const registerForm = useRef(null);

    const [address1, setAddress1] = useState('');
    const [areaId, setAreaId] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [stateId, setStateId] = useState('');
    const [cityId, setCityId] = useState('');
    const [countryId, setCountryId] = useState('');

    const [otdValaidation, setOtdValaidation] = useState(false);
    const [otdResndValidation, setOtdResndValidation] = useState(false);
    const [OTP, setOTP] = useState('');
    const [otpCount, setOtpCount] = useState(0);
    const [errorNameMessage, setErrorNameMessage] = useState(false);
    const [errorBnameMessage, setErrorBnameMessage] = useState(false);
    const [errorNumberMessage, setErrorNumberMessage] = useState(false);
    const [errorEmailMessage, setErrorEmailMessage] = useState(false);
    const [errorOtpMessage, setErrorOtpMessage] = useState(false);
    const [errorTypeMessage, setErrorTypeMessage] = useState(false);
    const [errorPincode, setErrorPincode] = useState(false);
    const [errorState, setErrorState] = useState(false);

    const { registerDetails, registerError } = useSelector(state => state.authReducer);
    const prevRegisterDetails = usePrevious(registerDetails);
    const prevRegisterError = usePrevious(registerError);
    //const context = useContext(Context);
    const dispatch = useDispatch();
    const { history } = props;
    const formRef = useRef('');

    const resendOtp = (e) => {
        setOTP('');
        emptyState();
        setOtdResndValidation(false);
        let fields = {
            name: fullName,
            email: emailAddress,
            mobile: phoneNumber,
            type: customerType,
            business: {
                name: businessName ? businessName : fullName,
                customerType: customerBusinessType
            },
            languageId: 1,
            address1: address1 ? address1 : '',
            pincodeId: pincodeId,
            countryId: countryId,
            stateId: stateId,
            cityId: cityId
        };
        dispatch({
            type: actions.REGISTER_START,
            registerData: fields
        });
    }

    const emptyAllState = () => {
        setErrorNameMessage(false);
        setErrorBnameMessage(false);
        setErrorNumberMessage(false);
        setErrorEmailMessage(false);
        setErrorTypeMessage(false);
        setErrorOtpMessage(false);
        setErrorPincode(false);
        setErrorState(false);
    }

    const emptyInput = () => {
        setFullName('');
        setCustomerBusinessType('');
        setBusinessName('');
        setPhoneNumber('');
        setEmailAddress('');
        setOTP('');
        setAddress1('');
        setAreaId('');
        setPincodeId('');
        setStateId('');
        setCityId('');
        setCountryId('');
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // let otpValidationCheck = true;
        let otpCustomerType = true;
        // let checkBusinessName = true;
        let emptyBusinessName = emptyValidation('Business Name', businessName);
        let emailValidation = customEmailValidation('Email', emailAddress);
        let emptyName = customAlaphabetValidation('Full Name', fullName);
        let phoneValidation = customPhoneValidation('Phone Number', phoneNumber, 10);
        let emptyCustomerBusinessType = emptyValidation('Customer Type', customerBusinessType, 'dropDown');
        if ((customerType === 'BUSINESS' && !emptyCustomerBusinessType.isValid) || (customerType === 'BUSINESS' && !emptyBusinessName.isValid)) {
            otpCustomerType = false
        }
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyState = emptyValidation('State', stateId, 'dropDown');
        emptyAllState();
        let checkOtp = { isValid: true, errors: '' };
        if (otdValaidation && otdResndValidation) {
            checkOtp = customPhoneValidation('Otp', OTP, 6);
        }

        if (emptyName.isValid && emailValidation.isValid &&
            phoneValidation.isValid && otpCustomerType && emptyPincode.isValid && emptyState.isValid && checkOtp.isValid) {
            let fields = {
                name: fullName,
                email: emailAddress,
                mobile: phoneNumber,
                type: customerType,
                business: {
                    name: businessName ? businessName : fullName,
                    customerType: customerBusinessType
                },
                languageId: 1,
                address1: address1 ? address1 : '',
                pincodeId: pincodeId,
                countryId: countryId,
                stateId: stateId,
                cityId: cityId
            };
            if (areaId) {
                fields["areaId"] = areaId;
            }

            if (otdValaidation && otdResndValidation) {
                fields["otp"] = OTP;
            }
            dispatch({
                type: actions.REGISTER_START,
                registerData: fields
            });
        } else {
            if (emptyName.errors !== '') {
                setErrorNameMessage(emptyName.errors);
            } if (customerType === 'BUSINESS' && emptyCustomerBusinessType.errors !== '') {
                setErrorTypeMessage(emptyCustomerBusinessType.errors);
            } if (customerType === 'BUSINESS' && emptyBusinessName.errors !== '') {
                setErrorBnameMessage(emptyBusinessName.errors);
            } if (phoneValidation.errors !== '') {
                setErrorNumberMessage(phoneValidation.errors);
            } if (emailValidation.errors !== '') {
                setErrorEmailMessage(emailValidation.errors);
            }
            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (emptyState.errors) {
                setErrorState(emptyState.errors);
            }
            if (checkOtp.errors) {
                setErrorOtpMessage(checkOtp.errors);
            }
            scrollToError();
        }
        handleHeight();
    }

    const emptyState = () => {
        setErrorOtpMessage('');
    }

    useEffect(() => {
        emptyAllState();
        checkLogin(props);
        //  dispatch({ type: addressActions.AREA_DETAILS_START, url: 'areas' });
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc',
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc',
            }
        });
        // dispatch({ type: addressActions.CITY_DETAILS_START, url: 'city' });
        // dispatch({ type: addressActions.PINCODE_DETAILS_START, url: 'pincode' });
        // handleHeight();
    }, []);

    useEffect(() => {
        function updateSize() {
            handleHeight();
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    const handleHeight = () => {
        let wH = window.innerHeight;
        if (registerForm?.current) {
            let rH = registerForm.current.clientHeight;
            let cH = registerForm.current.children[0];
            cH.children[1].style.height = "auto";
            cH.style.height = "auto";
            if (wH < rH) {
                registerForm.current.style.height = "100%";
                registerForm.current.classList.add("registerForm");
                cH.style.height = "100%";
                cH.children[1].style.height = "calc(100% - 190px)";
            }
        }
    }

    useEffect(() => {
        if (prevRegisterDetails !== undefined && registerDetails && prevRegisterDetails !== registerDetails) {
            if (otdValaidation && otdResndValidation) {
                history.push('/register/success');
                toast.dismiss();
                toast("Congratulations!!! Welcome to Younote. Your username and password have been sent to your registered email ID.");
                return false;
            }
            else {
                toast.dismiss();
                toast('A message has been sent to your registered email and mobile number with the OTP.');
            }
            setOtdValaidation(true);
            setOtdResndValidation(true);
            setTimeout(() => {
                handleHeight();
            }, 200)

        } else if (prevRegisterError !== undefined && registerError && prevRegisterError !== registerError) {
            let error = registerError.error.message.split("|");
            if (error[0] === 'email') {
                setOTP('');
                setOtdValaidation(false);
                setOtdResndValidation(false);
                setErrorEmailMessage(error[1]);
            } else if (error[0] === 'mobile') {
                setErrorNumberMessage(error[1]);
                setOTP('');
                setOtdValaidation(false);
                setOtdResndValidation(false);
            } else if (error[0] === 'otp') {
                if (otpCount === 3) {
                    emptyAllState();
                    emptyInput();
                    setCustomerType('INDIVIDUAL');
                    toast("Authentication failed!!");
                    setOtdValaidation(false);
                    setOtdResndValidation(false);
                }
                setOtpCount(otpCount + 1);
                setErrorOtpMessage('Invalid OTP');
            } else {
                setOTP('');
                setOtdValaidation(false);
                setOtdResndValidation(false);
                toast.error(error[0]);
            }
            setTimeout(() => {
                handleHeight();
            }, 200);
            scrollToError();
        }
    }, [registerDetails, registerError]);

    const handleReset = (value) => {
        emptyAllState();
        emptyInput();
        setOtdValaidation(false);
        setOtdResndValidation(false);
        if (value === 'INDIVIDUAL') {
            setCustomerBusinessType('OTHER');
        } else {
            setCustomerBusinessType('');
        }
        setCustomerType(value);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changeArea = (value) => {
        setAreaId(value);
    }

    const changePincode = (value) => {
        setPincodeId(value);
        setAreaId('');
        let a = pincodeDetails && pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: value }] }, order: 'id desc',
                }
            });
        }
        return [];
    }


    const changeCity = (value) => {
        setCityId(value);
        setAreaId('');
        setPincodeId('');
    }

    const changeState = (value) => {
        setStateId(value);
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
            changeStateApi(value);
        }
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }, order: 'id desc',

            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }, order: 'id desc',
            }
        });
    }

    const handleChangeCountry = (value) => {
        setCountryId(value);
        setStateId('');
        setCityId('');
        setPincodeId('');
        setAreaId('');
    }

    const handleFocus = (e) => {
        e.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }



    const classes = customStyles();
    return (
        <div className={clsx(classes.backgroundWhite, classes.boxBorder1)}>
            <Paper className={clsx(classes.authContainer)} sx={{ p: 2 }}>
                <Grid container className={clsx(classes.authRoot, classes.fullHei)}>
                    <Link to="/login" className={clsx(classes.customLogoLink)}>
                        <Avatar
                            alt="Logo"
                            src={logoImg}
                            className={clsx(classes.customLogo)}
                            variant={'square'}
                        />
                    </Link>
                    <Grid xxl={7} xl={7} lg={7} md={6} sm={5} item className={classes.mobileDisplay}>
                        <Image
                            alt="Register"
                            preview={false}
                            src={registerImg}
                            variant={'square'}
                            style={{ paddingTop: "35px" }}
                        />
                    </Grid>
                    <Grid xxl={5} xl={5} lg={5} md={6} sm={7} xs={12} item className={clsx(classes.registerForm, classes.customRegisterForm)}>
                        <Paper className={clsx(classes.cardSize, classes.loginForm)} ref={registerForm}>
                            <Box
                                component="form"
                                autoComplete="off"
                                onSubmit={(e) => handleSubmit(e)}
                                className={clsx(classes.removeUnderline, classes.registerPage)}>
                                <Row align={"top"} gutter={20}>
                                    <Col span={24}>
                                        <Typography variant="h6" className={clsx(classes.customTitle, classes.primaryFont, classes.bold, classes.typeAlignCenter)}>
                                            Register
                                        </Typography>
                                        <FormControl
                                            className={clsx(classes.margin20t, classes.textAlignCenter, classes.dropDownPointer, classes.customRadioButton)}
                                            variant={'standard'}
                                            fullWidth>
                                            <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Please choose an option that applies to you</FormLabel>
                                            <RadioGroup
                                                row
                                                className={clsx(classes.margin10t, classes.flexCenter)}
                                                value={customerType}
                                                onChange={(e) => handleReset(e.target.value)}
                                                id={idNamingConversion('Customer Type', 'register', 'Radio')}>
                                                {customerTypeList.length > 0 && customerTypeList.map((values, i) =>
                                                    <FormControlLabel value={values.id} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label={values.label} />
                                                )}
                                            </RadioGroup>
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row ref={formRef} align={"top"} gutter={20} className={classes.registerFormFields}>
                                    <Col span={24}>
                                        <TextField autoComplete='one-time-code'
                                            label={["Full Name ", <span key={'Full Name'} className={classes.colorRedRequired}> *</span>]}
                                            placeholder={"Full name of the contact person"}
                                            fullWidth
                                            variant={'standard'}
                                            error={errorNameMessage && true}
                                            helperText={errorNameMessage}
                                            id={idNamingConversion('Full Name', 'register', 'TextField')}
                                            className={clsx(classes.margin20t)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            value={fullName}
                                            onChange={(e) => setFullName(e.target.value)}
                                        />
                                    </Col>
                                    {customerType === 'BUSINESS' ?
                                        <Col span={24}>
                                            <AutoCompleteComponent
                                                name={["Business Type ", <span key={'Business Type'} className={classes.colorRedRequired}> *</span>]}
                                                placeholder={'Please select your business type'}
                                                heads={[{ 'key': 'label', 'name': 'Label' }]}
                                                details={customerBusinessTypeList}
                                                id={idNamingConversion('Business Type', 'register', 'DropDown')}
                                                parentValue={customObject(customerBusinessTypeList, customerBusinessType)}
                                                onChange={(data) => setCustomerBusinessType(data.id)}
                                                position={"bottom"}
                                                parentError={errorTypeMessage}
                                                customClasses={clsx(classes.margin20t, classes.textFieldColor)}
                                            /></Col> : ''}
                                    <Col span={24}>
                                        <TextField autoComplete='one-time-code'
                                            label={customerType === 'BUSINESS' ? ["Business Name ", <span key={"Business Name"} className={classes.colorRedRequired}> *</span>] : "Business Name"}
                                            placeholder={"Business name of the registered business"}
                                            fullWidth
                                            variant={'standard'}
                                            value={businessName}
                                            id={idNamingConversion('Business Name', 'register', 'TextField')}
                                            error={errorBnameMessage && true}
                                            helperText={errorBnameMessage}
                                            onFocus={(e) => handleFocus(e)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            className={clsx(classes.margin20t, classes.textFieldColor)}
                                            onChange={(e) => setBusinessName(e.target.value)}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <AutoCompleteComponent
                                            name={["State/Province ", <span key={"State/Province"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'name', 'name': 'State Name' },
                                            { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                            details={stateDetails}
                                            parentValue={customObject(stateDetails, stateId)}
                                            onChange={(data) => changeState(data.id)}
                                            position={"bottom"}
                                            id={idNamingConversion('State', 'register', 'DropDown')}
                                            parentError={errorState}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <AutoCompleteComponent
                                            name={["Pincode ", <span key={'Pincode'} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'code', 'name': 'Pincode' },
                                            { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                            details={pincodeDetails}
                                            id={idNamingConversion('Pincode', 'register', 'DropDown')}
                                            parentValue={customObject(pincodeDetails, pincodeId)}
                                            onChange={(data) => changePincode(data.id)}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                            parentError={errorPincode}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Row gutter={20}>
                                            <Col span={12}>
                                                <TextField autoComplete='one-time-code'
                                                    label=''
                                                    placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                    value={address1}
                                                    variant={'outlined'}
                                                    id={idNamingConversion('address', 'register', 'TextField')}
                                                    className={clsx(classes.margin20t, classes.customDescription)}
                                                    fullWidth
                                                    multiline
                                                    name={"address"}
                                                    onFocus={(e) => handleFocus(e)}
                                                    rows={6}
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        },
                                                        style: { height: 150 },
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textFieldLableColorCustom,
                                                    }}
                                                    onChange={(e) => setAddress1(e.target.value)}
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <AutoCompleteComponent
                                                    name={["Area"]}
                                                    heads={[{ 'key': 'name', 'name': 'Area Name' },
                                                    { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                                    { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                                    { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                                    details={areaDetails}
                                                    id={idNamingConversion('Area', 'register', 'DropDown')}
                                                    parentValue={customObject(areaDetails, areaId)}
                                                    onChange={(data) => { changeArea(data.id) }}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                />
                                                <AutoCompleteComponent
                                                    name={["Dist/City/Town"]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                                    { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                                    details={cityDetails}
                                                    id={idNamingConversion('City', 'register', 'DropDown')}
                                                    parentValue={customObject(cityDetails, cityId)}
                                                    onChange={(data) => changeCity(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin10t}
                                                />
                                                <AutoCompleteComponent
                                                    name={["Country"]}
                                                    heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                                    details={countryDetails}
                                                    id={idNamingConversion('Country', 'register', 'DropDown')}
                                                    parentValue={customObject(countryDetails, countryId)}
                                                    onChange={(data) => handleChangeCountry(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin10t}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <TextField autoComplete='one-time-code'
                                            label={["Phone Number ", <span key={'Phone Number'} className={classes.colorRedRequired}> *</span>]}
                                            type='number'
                                            fullWidth
                                            variant={'standard'}
                                            onFocus={(e) => handleFocus(e)}
                                            id={idNamingConversion('Phone Number', 'register', 'TextField')}
                                            error={errorNumberMessage && true}
                                            helperText={errorNumberMessage}
                                            InputProps={{
                                                startAdornment: <InputAdornment className={clsx(classes.textFieldColor)} position="start">(+91) </InputAdornment>,
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                            InputLabelProps={{
                                                className: clsx(classes.textFieldLableColorCustom, 'MuiFormLabel-filled'),
                                            }}
                                            value={phoneNumber}
                                            className={clsx(classes.margin20t, classes.textFieldColor)}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <TextField autoComplete='one-time-code'
                                            label={["Email Address ", <span key={'Email Address'} className={classes.colorRedRequired}> *</span>]}
                                            type='email'
                                            fullWidth
                                            error={errorEmailMessage && true}
                                            helperText={errorEmailMessage}
                                            value={emailAddress}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            id={idNamingConversion('Email Address', 'register', 'TextField')}
                                            onFocus={(e) => handleFocus(e)}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            variant={'standard'}
                                            className={clsx(classes.margin20t, classes.textFieldColor)}
                                            onChange={(e) => setEmailAddress(e.target.value)}
                                        />
                                    </Col>
                                    {otdValaidation ?
                                        <Col span={24}>
                                            <Typography
                                                className={clsx(classes.margin10t, classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColor)}
                                                variant={'h6'}
                                            >OTP Verification</Typography>
                                            <Typography
                                                className={clsx(classes.margin10t, classes.fonSize13)}
                                                variant={'subtitle1'}
                                            >We have sent an OTP to your registered mobile number / email Id. Please enter the received OTP</Typography>

                                            <TextField autoComplete='one-time-code'
                                                label={"Enter OTP"}
                                                type='number'
                                                fullWidth
                                                value={OTP}
                                                onWheel={(e) => e.target.blur()}
                                                error={errorOtpMessage && true}
                                                helperText={errorOtpMessage}
                                                id={idNamingConversion('Enter OTP', 'register', 'TextField')}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setOTP((e.target.value = 0)) : setOTP(e.target.value) : setOTP(e.target.value)}
                                            />
                                            <Typography
                                                className={clsx(classes.margin10t, classes.fonSize13, classes.textFieldColor)}
                                                variant={'subtitle1'}
                                            >Didn't receive OTP?
                                                <NavLink to={'#'} onClick={() => resendOtp()} id={idNamingConversion('Resend OTP', 'register', 'Link')} className={clsx(classes.marginLeft10, classes.textDecoration, classes.color, classes.bold)}>
                                                    Resend OTP
                                                </NavLink>
                                            </Typography>
                                        </Col> : <></>
                                    }
                                </Row>
                                <Row align={"top"} gutter={10}>
                                    {otdValaidation ? <Col span={24}><Button
                                        className={clsx(classes.modalBtn, classes.margin20t, { [classes.loading]: registerLoader }, { [classes.disabled]: OTP.length < 6 })}
                                        type="submit"
                                        fullWidth
                                        id={idNamingConversion('Register', 'register', 'Button')}
                                        variant={'contained'}>
                                        Register
                                    </Button></Col> : <Col span={24}><Button
                                        className={clsx(classes.modalBtn, classes.margin20t, { [classes.loading]: registerLoader })}
                                        type="submit"
                                        fullWidth
                                        id={idNamingConversion('Register & Get OTP', 'register', 'Button')}
                                        variant={'contained'}
                                    >Register & Get OTP
                                    </Button></Col>
                                    }
                                    <Col span={24}>
                                        <Row gutter={10}>
                                            <Col xxl={12} xl={12} lg={12} md={6} sm={6} xs={6}>
                                                <Typography
                                                    className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}
                                                    variant={'subtitle1'}
                                                ><div className={classes.mobileDisplayRegister}>Already have an account?</div>
                                                    <Link
                                                        to={'/login'}
                                                        id={idNamingConversion('Login', 'register', 'Link')}
                                                        className={clsx(classes.marginLeft10, classes.textDecoration, classes.color, classes.bold)}
                                                    >Login</Link>
                                                </Typography>
                                            </Col>
                                            <Col xxl={12} xl={12} lg={12} md={18} sm={18} xs={18} className={clsx(classes.textAlignRight)}>
                                                <NormalSelect name="lang" id={idNamingConversion('Language', 'register', 'DropDown')} signedIn={false} margin10t={classes.margin20t} />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid >
            </Paper >
        </div >
    )
}

export default Register